/**
 * 请求拦截
 * @param {Object} http
 */
import { requestSetting } from './setting.js';
import { token } from '@/common/utils/token/token.js';

export const requestInterceptors = (vm) => {
    uni.$uv.http.interceptors.request.use((config) => { // 可使用async await 做异步操作
		if(config.custom.isLoading == 1)		 {
			uni.$sk.func.showLoading();
		}
		
		let requestUrl = uni.$sk.func.trim(config.baseURL, '/', 'right');
		requestUrl += '/' + uni.$sk.func.trim(config.url, '/', 'left');
		
		switch(config.custom.type) {
			case 'getFile':
			
				break;
				
			default:
				config.header['content-type'] = 'application/json';
				config.header['X-Requested-With'] = 'xmlhttprequest';
				
				let userToken = token.get();
				if(userToken) {
					config.header.Authorization = 'Bearer ' + userToken;
				}
				
				let secret = uni.$sk.func.getSecret();
				config.header.ClientAgent = secret;
						
				let timestamp = uni.$sk.func.getTimestamp();
				let nonceStr = requestSetting.getNonceStr();
				let sign = requestSetting.getRequestSign(secret, timestamp, nonceStr, config.method === 'get' ? {} : config.data);
				if(config.method.toUpperCase() === 'GET') {
					config.params.timestamp = timestamp;
					config.params.nonceStr = nonceStr;
					config.params.sign = sign;	
				} else {
					config.url = uni.$sk.func.jointUrl(config.url, {
						timestamp,
						nonceStr,
						sign
					})
				}
				break;
		}
		return config;
    }, (config) => {
		// 可使用async await 做异步操作
		Promise.reject(config)
	})
}

 